interface ValidationErrorItem {
  msg?: string;
}

/**
 * Extracts a displayable message from an Axios error. FastAPI returns
 * `detail` as a plain string for HTTPException, but as an array of
 * {type, loc, msg, ...} objects for Pydantic validation errors (422) —
 * handle both, since rendering the array directly crashes React.
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;

  if (typeof detail === "string" && detail) return detail;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => (item as ValidationErrorItem)?.msg)
      .filter((msg): msg is string => typeof msg === "string" && msg.length > 0);
    if (messages.length > 0) return messages.join(" ");
  }

  return fallback;
}
